<template>
  <section>
    <imgHeader imgUrl="/img/2公司介绍-banner.jpg" />
    <div class="introduce w">
      <img
          src="/img/2公司介绍-logo.png"
          STYLE="height: 60px"
          alt=""
          data-aos="fade-up"
          data-aos-anchor-placement="bottom-bottom"
          data-aos-duration="1000"
      />
      <h3
          class="title"
          data-aos="fade-up"
          data-aos-anchor-placement="bottom-bottom"
          data-aos-duration="1000"
      >
        {{ $t('introduce.title') }}
      </h3>
      <div class="line line1"></div>
      <div class="text">
        <p
            data-aos="fade-up"
            data-aos-anchor-placement="bottom-bottom"
            data-aos-duration="1000"
        >
          {{ $t('introduce.desc1') }}
        </p>
        <div
            class="img-introduce flex"
            data-aos="fade-up"
            data-aos-anchor-placement="bottom-bottom"
            data-aos-duration="1000"
        >
          <img src="/img/2.公司介绍1.jpg" alt="" />
        </div>
        <p
            data-aos="fade-up"
            data-aos-anchor-placement="bottom-bottom"
            data-aos-duration="1000"
        >
          {{ $t('introduce.desc2') }}
        </p>
        <div
            class="flowchart"
            data-aos="fade-up"
            data-aos-anchor-placement="bottom-bottom"
            data-aos-duration="1000"
        >
          <div class="flowchartTop">
            <div>{{$t('introduce.transport')}}</div>
            <div>{{$t('introduce.transshipment')}}</div>
          </div>
          <div class="flowchartBottom">
            <div>{{$t('introduce.procurement')}}</div>
            <div>{{$t('introduce.warehousing')}}</div>
            <div>{{$t('introduce.customsClearance')}}</div>
          </div>
<!--          <img src="/img/2公司介绍-流程图.png" alt="" />-->
        </div>
        <p
            data-aos="fade-up"
            data-aos-anchor-placement="bottom-bottom"
            data-aos-duration="1000"
        >
          {{ $t('introduce.desc3') }}
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { t } from '@/VueI18n'

export default {
  name: 'Introduce',
  data() {
    return {
      desc1: t('introduce.desc1'),
      desc2: t('introduce.desc2'),
      desc3: t('introduce.desc3'),
    }
  },
  watch: {
    '$i18n.locale'() {
      this.updateText()
    }
  },
  mounted() {
    this.updateText()
  },
  methods: {
    updateText() {
      this.desc1 = t('introduce.desc1')
      this.desc2 = t('introduce.desc2')
      this.desc3 = t('introduce.desc3')
    }
  },
}
</script>

<style lang="scss" scoped>
.introduce {
  text-align: center;
}
.text {
  margin-top: 20px;
  margin-bottom: 90px;
  font-size: 18px;
  color: #333;
  text-align: left;
  p {
    margin-bottom: 36px;
    line-height: 1.5;
    text-indent: 2em;
    text-align: justify;
  }
}
.smallCon {
  flex-wrap: wrap;
  img {
    border: 2px solid transparent;
    width: 412px;
    height: 214px;
    &:nth-child(1),
    &:nth-child(2) {
      border-top: none;
    }
    &:nth-child(3),
    &:nth-child(4) {
      border-bottom: none;
    }
  }
}
.flowchart {
  width: 1144px;
  height: 218px;
  background-image: url("/img/2公司介绍-流程图.png");
  margin: 0 auto 36px;
  position: relative;
  .flowchartTop {
    display: flex;
    justify-content: space-between;
    position: absolute;
    left: 286px;
    top: 109px;
    width: 550px;
    div {
      width: 24px;
      white-space: nowrap;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: nowrap;
    }
  }
  .flowchartBottom {
    display: flex;
    justify-content: space-between;
    position: absolute;
    left: 27px;
    top: 183px;
    width: 1076px;
    div {
      width: 24px;
      white-space: nowrap;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: nowrap;
    }
  }
}
</style>